export const MAX_PAGES = 5;
export const NEXT_PREV_PAGE_COUNT = 4;
